import { createUseStyles } from 'react-jss'

import { desktop } from '../../theme'


export default createUseStyles({
  container: {
    display: 'block',
    textAlign: 'center',
    paddingBottom: '1rem',
    paddingTop: '1rem',
  },
  countDown: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    fontSize: '3.6rem',
    ...desktop({
      fontSize: '5.2rem',
    }),
  },
})
